import React from 'react'
import { useLocation, useParams } from 'react-router'
import { Box } from '@chakra-ui/core'
import { QuantityBox } from '@engyalo/storefront-components'
import { LinkButton } from '../../lib/types'
import { useRecoilValue } from 'recoil'
import { ILocationSearch } from '../../utils/mode'
import { cartStatsState } from '../../recoil/selectors'

export const CartIcon: React.FC = () => {
  const location = useLocation<ILocationSearch>()
  const { customer, order } = useParams()
  const { totalNum } = useRecoilValue(cartStatsState)

  return (
    <Box pos="relative">
      <LinkButton
        to={{ pathname: `/${customer}/${order}/cart`, search: location.search }}
        h="100%"
        w="32px"
        background="transparent"
        borderColor="unset"
        style={{
          color: '#000',
        }}
        size="lg"
        aria-label="cart"
        icon="settings"
      />
      <Box pos="absolute" right="0" top="0">
        {totalNum > 0 ? <QuantityBox data-testid="quantity-badge" value={totalNum} size="small" /> : null}
      </Box>
    </Box>
  )
}
